import { render } from "./HairColorList.vue?vue&type=template&id=36c8538a&scoped=true"
import script from "./HairColorList.vue?vue&type=script&lang=js"
export * from "./HairColorList.vue?vue&type=script&lang=js"

import "./HairColorList.vue?vue&type=style&index=0&id=36c8538a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c8538a"]])

export default __exports__